module.exports = __webpack_public_path__ + "static/media/2C.94b4a5b0.svg";